module.exports = __webpack_public_path__ + "3724d110a9b09aacb88d74c4cc0c9cdb.pdf";